module.exports = __webpack_public_path__ + "img/insular-header.eeaeb0e6.png";